import './DecisionFlowApplication.css';

import questionImage from '../images/question.png';

import ClassificationOption from '../ClassificationOption/ClassificationOption';
import FormulaDragAndDrop from '../FormulaDragAndDrop/FormulaDragAndDrop';



const DecisionFlowApplication = ({
  question,

  decisionPhase,
  decisionStepIndex,

  decisionAnswer,
  decisionSelectedAnswers = [],

  shuffledOptions = [],

dragOptions = [],
dragAnswers = [],

formulaOptions = [],
formulaAnswers = {},
onFormulaAnswersChange,

classificationAnswers = {},

  
  isAnswerChecked,

  onSimpleAnswerChange,
  onMultipleAnswerChange,
  onDragAnswersChange,
  onDragSelectionChange,
  onClassificationAnswersChange,

  getOptionValueById,
  getSlotsCount,
  finalImage,
}) => {
  if (!question) {
    return null;
  }

  const steps = Array.isArray(question.steps)
    ? question.steps
    : [];

  const currentStep =
    steps[decisionStepIndex] ?? null;

const getStepOptionType = (step) => {
  if (!step) {
    return 'simpleOption';
  }

  if (step.type === 'formulaDragAndDrop') {
    return 'formulaDragAndDrop';
  }

  return (
    step.optionType ||
    step.stepType ||
    (
      typeof step.type === 'string' &&
      step.type.startsWith('option')
        ? step.type
        : 'simpleOption'
    )
  );
};


const renderDecisionStepProgress = () => {
  if (steps.length === 0) {
    return null;
  }

  return (
    <div
      className="decision-step-progress-bc"
      style={{
        '--decision-step-count':
          steps.length,
      }}
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={steps.length}
      aria-valuenow={
        decisionStepIndex + 1
      }
      aria-label={`Pasul ${
        decisionStepIndex + 1
      } din ${steps.length}`}
    >
      {steps.map((step, index) => {
        const isCompleted =
          index < decisionStepIndex ||
          (
            index ===
              decisionStepIndex &&
            isAnswerChecked
          );

        const isCurrent =
          index ===
            decisionStepIndex &&
          !isAnswerChecked;

        return (
          <div
            key={`decision-progress-step-${index}`}
            className={[
              'decision-step-card-bc',
              isCompleted
                ? 'decision-step-card-completed-bc'
                : '',
              isCurrent
                ? 'decision-step-card-current-bc'
                : '',
            ]
              .filter(Boolean)
              .join(' ')}
            aria-label={
              isCompleted
                ? `Pasul ${
                    index + 1
                  } finalizat`
                : isCurrent
                  ? `Pasul ${
                      index + 1
                    } curent`
                  : `Pasul ${
                      index + 1
                    } neinceput`
            }
          >
          
          </div>
        );
      })}
    </div>
  );
};

  const optionType =
    getStepOptionType(currentStep);

    const isFormulaDragAndDrop =
  optionType === 'formulaDragAndDrop';

  const isMultipleOption =
    optionType === 'multipleOption';

    const isClassificationOption =
  optionType === 'classificationOption';


  const isFormulaLayout =
    optionType === 'optionDragAndDropFormula' ||
    optionType === 'optionDragAndDropFormulaLeft' ||
    optionType === 'optionDragAndDropFormulaRight';

  const isFormulaLeftLayout =
    optionType === 'optionDragAndDropFormulaLeft';

  const isFormulaRightLayout =
    optionType === 'optionDragAndDropFormulaRight';

  const isTaccountLayout =
    optionType === 'optionDragTaccount';

  const isDragOption =
    optionType === 'optionDragAndDrop' ||
    isFormulaLayout ||
    isTaccountLayout;

  const handleSimpleOptionClick = (option) => {
    if (isAnswerChecked) {
      return;
    }

    onSimpleAnswerChange?.(option);
  };

  const handleMultipleOptionClick = (option) => {
    if (isAnswerChecked) {
      return;
    }

    onMultipleAnswerChange?.(option);
  };

  const getSimpleOptionClassName = (option) => {
    if (isAnswerChecked) {
      if (option === currentStep?.correctAnswer) {
        return 'simple-application-correct-bc';
      }

      if (option === decisionAnswer) {
        return 'simple-application-incorrect-bc';
      }

      return 'simple-application-default-bc';
    }

    if (option === decisionAnswer) {
      return 'simple-application-selected-bc';
    }

    return 'simple-application-default-bc';
  };








  const getMultipleOptionClassName = (option) => {
    const selected =
      decisionSelectedAnswers.includes(option);

    const correctAnswers =
      Array.isArray(currentStep?.correctAnswer)
        ? currentStep.correctAnswer
        : [];

    const correct =
      correctAnswers.includes(option);

    if (isAnswerChecked) {
      if (correct) {
        return 'align-multiple-items-bc border-correct';
      }

      if (selected) {
        return 'align-multiple-items-bc border-incorrect';
      }

      return 'align-multiple-items-bc';
    }

    if (selected) {
      return 'align-multiple-items-bc border-selected';
    }

    return 'align-multiple-items-bc';
  };

  /* =====================================================
     DRAG AND DROP
     ===================================================== */

  const slotsCount =
    getSlotsCount?.(currentStep) ?? 0;

  const safeDragAnswers =
    Array.isArray(dragAnswers) &&
    dragAnswers.length === slotsCount
      ? dragAnswers
      : Array(slotsCount).fill(null);

  const updateDragAnswers = (nextAnswers) => {
    onDragAnswersChange?.(nextAnswers);

    const hasSelection = nextAnswers.some(
      (item) =>
        item !== null &&
        item !== undefined &&
        item !== ''
    );

    onDragSelectionChange?.(hasSelection);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const readDraggedOptionId = (event) => {
    try {
      const jsonPayload =
        event.dataTransfer.getData(
          'application/json'
        );

      if (jsonPayload) {
        const parsedPayload =
          JSON.parse(jsonPayload);

        if (parsedPayload?.id) {
          return parsedPayload.id;
        }
      }
    } catch (error) {
      // fallback pe text/plain
    }

    return event.dataTransfer.getData(
      'text/plain'
    );
  };

  const handleDragStart = (
    event,
    optionId
  ) => {
    if (
      isAnswerChecked ||
      !optionId
    ) {
      return;
    }

    event.dataTransfer.setData(
      'application/json',
      JSON.stringify({
        id: optionId,
      })
    );

    event.dataTransfer.setData(
      'text/plain',
      String(optionId)
    );

    event.dataTransfer.effectAllowed =
      'move';
  };

  const placeOptionInSlot = (
    slotIndex,
    optionId
  ) => {
    if (
      isAnswerChecked ||
      !optionId
    ) {
      return;
    }

    const nextAnswers = [
      ...safeDragAnswers,
    ];

    const existingIndex =
      nextAnswers.indexOf(optionId);

    if (existingIndex !== -1) {
      nextAnswers[existingIndex] = null;
    }

    nextAnswers[slotIndex] = optionId;

    updateDragAnswers(nextAnswers);
  };

  const handleDropOnSlot = (
    event,
    slotIndex
  ) => {
    event.preventDefault();

    const optionId =
      readDraggedOptionId(event);

    if (!optionId) {
      return;
    }

    placeOptionInSlot(
      slotIndex,
      optionId
    );
  };

  const handleRemoveFromSlot = (
    slotIndex
  ) => {
    if (isAnswerChecked) {
      return;
    }

    const nextAnswers = [
      ...safeDragAnswers,
    ];

    nextAnswers[slotIndex] = null;

    updateDragAnswers(nextAnswers);
  };

  const handleOptionClick = (
    optionId
  ) => {
    if (isAnswerChecked) {
      return;
    }

    const firstEmptySlot =
      safeDragAnswers.findIndex(
        (item) =>
          item === null ||
          item === undefined ||
          item === ''
      );

    if (firstEmptySlot !== -1) {
      placeOptionInSlot(
        firstEmptySlot,
        optionId
      );
    }
  };

  const renderDragSlot = (
    slotIndex
  ) => {
    const optionId =
      safeDragAnswers[slotIndex] ?? null;

    const value =
      getOptionValueById?.(
        currentStep,
        optionId
      ) ?? '';

    const expectedAnswers =
      Array.isArray(
        currentStep?.correctAnswer
      )
        ? currentStep.correctAnswer
        : [];

const normalizeDragValue = (item) =>
  String(item ?? '')
    .trim()
    .toLowerCase();

const getAnswerScopeForSlot = (index) => {
  const answerMode =
    currentStep?.answerMode || 'ordered';

  if (answerMode === 'unordered') {
    return {
      startIndex: 0,
      endIndex: slotsCount,
    };
  }

  if (
    answerMode === 'unorderedPerRow' &&
    Array.isArray(currentStep?.rows)
  ) {
    let currentIndex = 0;

    for (const row of currentStep.rows) {
      const rowSlots =
        Math.max(
          0,
          Number(row?.slots) || 0
        );

      const rowStart = currentIndex;
      const rowEnd =
        currentIndex + rowSlots;

      if (
        index >= rowStart &&
        index < rowEnd
      ) {
        return {
          startIndex: rowStart,
          endIndex: rowEnd,
        };
      }

      currentIndex = rowEnd;
    }
  }

  return {
    startIndex: index,
    endIndex: index + 1,
  };
};

const isDragValueCorrectForSlot = (
  index,
  currentValue
) => {
  if (
    !isAnswerChecked ||
    currentValue === null ||
    currentValue === undefined ||
    currentValue === ''
  ) {
    return false;
  }

  const answerMode =
    currentStep?.answerMode || 'ordered';

  if (answerMode === 'ordered') {
    return (
      normalizeDragValue(currentValue) ===
      normalizeDragValue(
        expectedAnswers[index]
      )
    );
  }

  const {
    startIndex,
    endIndex,
  } = getAnswerScopeForSlot(index);

  const expectedScope =
    expectedAnswers.slice(
      startIndex,
      endIndex
    );

  const selectedScope =
    safeDragAnswers
      .slice(startIndex, endIndex)
      .map((optionId) =>
        getOptionValueById?.(
          currentStep,
          optionId
        )
      );

  const normalizedCurrentValue =
    normalizeDragValue(currentValue);

  const localIndex =
    index - startIndex;

  /*
   * Verifica si numarul aparitiilor, astfel incat
   * sa functioneze corect si cu valori duplicate.
   */
  const selectedOccurrences =
    selectedScope
      .slice(0, localIndex + 1)
      .filter(
        (item) =>
          normalizeDragValue(item) ===
          normalizedCurrentValue
      ).length;

  const expectedOccurrences =
    expectedScope.filter(
      (item) =>
        normalizeDragValue(item) ===
        normalizedCurrentValue
    ).length;

  return (
    expectedOccurrences > 0 &&
    selectedOccurrences <=
      expectedOccurrences
  );
};

const isCorrectSlot =
  isDragValueCorrectForSlot(
    slotIndex,
    value
  );

const isWrongSlot =
  isAnswerChecked &&
  value !== '' &&
  !isCorrectSlot;
    const isPrefilled =
      Array.isArray(
        currentStep?.prefilledSlots
      ) &&
      currentStep.prefilledSlots[
        slotIndex
      ] !== null &&
      currentStep.prefilledSlots[
        slotIndex
      ] !== undefined &&
      currentStep.prefilledSlots[
        slotIndex
      ] !== '';

    return (
      <button
        key={`decision-slot-${slotIndex}`}
        type="button"
        className={[
          'decision-dnd-slot-bc',
          value ? 'filled' : '',
          isCorrectSlot ? 'correct' : '',
          isWrongSlot ? 'incorrect' : '',
          isPrefilled ? 'prefilled' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        onDragOver={handleDragOver}
        onDrop={(event) =>
          handleDropOnSlot(
            event,
            slotIndex
          )
        }
        onClick={() => {
          if (!isPrefilled) {
            handleRemoveFromSlot(
              slotIndex
            );
          }
        }}
        draggable={
          !isAnswerChecked &&
          !isPrefilled &&
          Boolean(optionId)
        }
        onDragStart={(event) => {
          if (
            optionId &&
            !isPrefilled
          ) {
            handleDragStart(
              event,
              optionId
            );
          }
        }}
        disabled={
          isAnswerChecked ||
          isPrefilled
        }
      >
        {value && (
          <span className="decision-dnd-slot-bc-filled-style">
            {String(value)}
          </span>
        )}
      </button>
    );
  };

  const renderDragLayout = () => {
    if (!currentStep) {
      return null;
    }

    if (isTaccountLayout) {
      const leftCount =
        Math.ceil(slotsCount / 2);

      const rightCount =
        slotsCount - leftCount;

      return (
        <div className="decision-taccount-layout-bc">
          <div className="decision-taccount-header-bc">
            <span>Debit</span>
            <span>Credit</span>
          </div>

          <div className="decision-taccount-columns-bc">
            <div className="decision-taccount-column-bc">
              {Array.from(
                { length: leftCount },
                (_, index) =>
                  renderDragSlot(index)
              )}
            </div>

            <div className="decision-taccount-column-bc">
              {Array.from(
                { length: rightCount },
                (_, index) =>
                  renderDragSlot(
                    leftCount + index
                  )
              )}
            </div>
          </div>
        </div>
      );
    }

    if (isFormulaLayout) {
      return (
        <div
          className={[
            'decision-formula-layout-bc',
            isFormulaLeftLayout
              ? 'decision-formula-layout-left-bc'
              : '',
            isFormulaRightLayout
              ? 'decision-formula-layout-right-bc'
              : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {isFormulaRightLayout && (
            <div className="decision-formula-static-side-bc">
              {currentStep.leftLabel ||
                currentStep.leftText ||
                currentStep.leftSide ||
                ''}
            </div>
          )}

          <div className="decision-formula-slots-bc">
            {Array.from(
              { length: slotsCount },
              (_, index) =>
                renderDragSlot(index)
            )}
          </div>

          {isFormulaLeftLayout && (
            <div className="decision-formula-static-side-bc">
              {currentStep.rightLabel ||
                currentStep.rightText ||
                currentStep.rightSide ||
                ''}
            </div>
          )}
        </div>
      );
    }

    const rows =
      Array.isArray(currentStep.rows) &&
      currentStep.rows.length > 0
        ? currentStep.rows
        : [
            {
              label: '',
              slots: slotsCount,
            },
          ];

    let currentSlotIndex = 0;

    return (
      <div className="decision-dnd-container-bc">
        {rows.map((row, rowIndex) => {
          const rowSlots = Math.max(
            0,
            Number(row?.slots) || 0
          );

          const startIndex =
            currentSlotIndex;

          currentSlotIndex += rowSlots;

          return (
            <div
              key={`decision-row-${rowIndex}`}
              className="decision-dnd-row-bc"
            >
              {row?.label && (
                <p className="decision-dnd-row-label-bc">
                  {row.label}
                </p>
              )}

              <div className="decision-dnd-row-slots-bc">
                {Array.from(
                  { length: rowSlots },
                  (_, index) =>
                    renderDragSlot(
                      startIndex + index
                    )
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  /* =====================================================
     INTRO
     ===================================================== */

  if (decisionPhase === 'intro') {
    return (
      <div className="quiz-content-scroll-bc">
        <div className="simple-application-container-bc">
          <div className="simple-application-instruction-bc">
            <div className="simple-application-content-bc">
              {question.title && (
                <div className="title-simple-select-align">
                
                    <div className="question-text-bc">
                      {question.title}
                    </div>
                 
                </div>
              )}

              {question.context && (
                <div
                  className="simple-application-context-bc"
                  dangerouslySetInnerHTML={{
                    __html:
                      question.context,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* =====================================================
     FINAL
     ===================================================== */

if (decisionPhase === 'final') {
  return (
    <div className="simple-application-container-bc">
      <div className="simple-application-instruction-bc">
        <div className="simple-application-content-bc">
          <h2 className="motivational-title">
            Aplicatie finalizata
          </h2>

          <div
            className="decision-final-message-bc"
            dangerouslySetInnerHTML={{
              __html:
                question.finalMessage ||
                question.finalExplanation ||
                '<p>Aplicatie finalizata cu succes.</p>',
            }}
          />

          {finalImage && (
            <div className="lesson-image-container">
              <img
                src={finalImage}
                alt="Conti revendicat"
                className="lesson-image-finishandsend"
              />
            </div>
          )}

          <p className="decision-final-score-bc">
            <b>
              Scor: {steps.length} / {steps.length}
            </b>{' '}
            ⭐⭐⭐
          </p>
        </div>
      </div>
    </div>
  );
}

  if (
    decisionPhase !== 'steps' ||
    !currentStep
  ) {
    return null;
  }

  /* =====================================================
     STEPS
     ===================================================== */

  return (
    <div className="quiz-content-scroll-bc">
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
        <div className="simple-application-content-bc">
  {renderDecisionStepProgress()}

  {currentStep.context && (
              <div
                className="simple-application-context-bc"
                dangerouslySetInnerHTML={{
                  __html:
                    currentStep.context,
                }}
              />
            )}

           <div className="simple-application-question-bc">
  <div className="decision-question-wrapper-bc">
    <img
      src={questionImage}
      alt="Intrebare"
      className="decision-question-icon-bc"
    />

    <p>{currentStep.question}</p>
  </div>
</div>

      {!isMultipleOption &&
  !isDragOption &&
  !isClassificationOption &&
  !isFormulaDragAndDrop && (
                <div className="simple-application-buttons-bc">
                  {shuffledOptions.map(
                    (option, index) => (
                      <div
                        key={`${String(
                          option
                        )}-${index}`}
                        className={getSimpleOptionClassName(
                          option
                        )}
                        onClick={() =>
                          handleSimpleOptionClick(
                            option
                          )
                        }
                        role="button"
                        tabIndex={
                          isAnswerChecked
                            ? -1
                            : 0
                        }
                        onKeyDown={(
                          event
                        ) => {
                          if (
                            event.key ===
                              'Enter' ||
                            event.key === ' '
                          ) {
                            event.preventDefault();

                            handleSimpleOptionClick(
                              option
                            );
                          }
                        }}
                      >
                        <p>{option}</p>
                      </div>
                    )
                  )}
                </div>
              )}

            {isMultipleOption && (
              <div className="multiple-answer-lessons-bc">
                {shuffledOptions.map(
                  (option, index) => {
                    const selected =
                      decisionSelectedAnswers.includes(
                        option
                      );

                    return (
                      <div
                        key={`${String(
                          option
                        )}-${index}`}
                        className={getMultipleOptionClassName(
                          option
                        )}
                        onClick={() =>
                          handleMultipleOptionClick(
                            option
                          )
                        }
                        role="checkbox"
                        aria-checked={selected}
                        tabIndex={
                          isAnswerChecked
                            ? -1
                            : 0
                        }
                        onKeyDown={(
                          event
                        ) => {
                          if (
                            event.key ===
                              'Enter' ||
                            event.key === ' '
                          ) {
                            event.preventDefault();

                            handleMultipleOptionClick(
                              option
                            );
                          }
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={selected}
                          readOnly
                          className="check-box-multiple-answer-bc"
                        />

                        <span className="cursor-pointer">
                          {option}
                        </span>
                      </div>
                    );
                  }
                )}
              </div>
            )}


{isClassificationOption && (
  <ClassificationOption
    key={`classification-${decisionStepIndex}`}
    question={currentStep}
    categories={currentStep.categories}
    options={shuffledOptions}
    answers={classificationAnswers}
    isAnswerChecked={isAnswerChecked}
    onAnswersChange={onClassificationAnswersChange}
    showQuestion={false}
    showContext={false}
     useScrollWrapper={false}
  />
)}


{isFormulaDragAndDrop && (
  <FormulaDragAndDrop
    key={`formula-drag-${decisionStepIndex}`}
    question={currentStep}
    options={formulaOptions}
    selectedAnswers={formulaAnswers}
    expectedAnswers={currentStep.correctAnswer || {}}
    isAnswerChecked={isAnswerChecked}
    formulaRows={currentStep.formulaRows || []}
    onAnswersChange={onFormulaAnswersChange}
    showQuestion={false}
     useScrollWrapper={false}
  />
)}


        {isDragOption && (
  <>
    {renderDragLayout()}

    <div
      className={[
        'decision-dnd-options-bc',
        isAnswerChecked
          ? 'decision-dnd-options-hidden-bc'
          : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onDragOver={handleDragOver}
    >
      {dragOptions.map(
        (option) => {
          const isUsed =
            safeDragAnswers.includes(
              option.id
            );

          return (
            <button
              key={option.id}
              type="button"
              className={`decision-dnd-option-bc ${
                isUsed
                  ? 'used'
                  : ''
              }`}
              draggable={
                !isAnswerChecked &&
                !isUsed
              }
              onDragStart={(
                event
              ) => {
                if (
                  !isAnswerChecked &&
                  !isUsed
                ) {
                  handleDragStart(
                    event,
                    option.id
                  );
                }
              }}
              onClick={() => {
                if (
                  !isAnswerChecked &&
                  !isUsed
                ) {
                  handleOptionClick(
                    option.id
                  );
                }
              }}
              disabled={
                isAnswerChecked ||
                isUsed
              }
            >
              {!isUsed &&
                option.label}
            </button>
          );
        }
      )}
    </div>
  </>
)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DecisionFlowApplication;